import { render, staticRenderFns } from "./ClassMaterialEdit.vue?vue&type=template&id=1f3d6194&scoped=true&"
import script from "./ClassMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./ClassMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d6194",
  null
  
)

export default component.exports